import { combineReducers } from 'redux';

import { ACTION_ADD_BALANCE_ADJUSTMENTS } from '../actionTypes';


const byId = (state = {}, action) => {
  switch (action.type) {
    case ACTION_ADD_BALANCE_ADJUSTMENTS:
      return { ...state, ...action.payload.balanceAdjustments };

    default:
      return state;
  }
};

export default combineReducers({
  byId,
});
